import { createAction } from "redux-actions";

import getColourEnrichments from "./getColourEnrichments";
import { UPDATE_SEARCH_TERM } from "../constants";

const updateSearchTerm = createAction(UPDATE_SEARCH_TERM);

export { getColourEnrichments, updateSearchTerm };
